import { useNavigate } from 'react-router-dom';
import { useApp } from '../../store/appStores';
import { useEffect } from 'react';

export const useLoadInitialData = () => {
  const set = useApp((s) => s.set);
  const dataLoaded = useApp((s) => s.dataLoaded);
  const token = useApp((s) => s.token);
  const loadData = useApp((s) => s.loadData);
  const navigate = useNavigate();

  useEffect(() => {
    if (token && !dataLoaded) {
      localStorage.removeItem('username');
      localStorage.removeItem('password');
      loadData().then(() => navigate({ search: '' }, { replace: true }));
    }
  }, [dataLoaded, token, set, loadData, navigate]);
};
